'use client'

import { Toaster as ToasterWrapper } from 'sonner'

export default function Toaster() {
   return (
      <ToasterWrapper 
         toastOptions={{ 
            style: { 
               borderRadius: '4px', 
               fontFamily: 'var(--type-mono)', 
               lineHeight: 1, 
               height: '48px', 
               textTransform: 'uppercase', 
               letterSpacing: '.2px' 
            }
         }} 
      />
   )
}